(function() {
	'use strict';

	angular
		.module('assetCommon')
		.factory('bucketService', bucketService);

	function bucketService($http, $q, localSettingsService, _, utility, uriUtility, assetCommonConfig) {
		var buckets = null;
		var defaultBucket = { id: 'LogosInternal' };
		var currentBucket = null;

		var setting = localSettingsService.createSettingAccessor('bucket', function () {
			return buckets === null ? defaultBucket : buckets[0] || defaultBucket;
		});

		function mapBucket(bucket) {
			return {
				id: bucket.id,
				name: utility.toTitleCase(utility.breakCamelCaseWords(bucket.id).replace(/-/g, ' ')),
				readPermission: bucket.readPermission,
				writePermission: bucket.writePermission
			};
		}

		function getCurrentBucket() {
			if (currentBucket)
				return currentBucket;

			var savedBucket = setting.get();
			currentBucket = savedBucket && _.find(buckets, { id: savedBucket.id }) || (buckets && buckets[0]) || defaultBucket;
			return currentBucket;
		}

		function setCurrentBucket(bucket) {
			currentBucket = _.find(buckets, { id: bucket.id });
			setting.set(currentBucket);
		}

		var getBucketsPromise;
		function getBucketsAsync() {
			if (getBucketsPromise)
				return getBucketsPromise;

			getBucketsPromise = $http.get(uriUtility.fromPattern(assetCommonConfig.assetServiceBaseUri + 'buckets?limit=100'))
				.then(function (response) {
					buckets = response.data.items.map(mapBucket);
					return buckets;
				});

			return getBucketsPromise;
		}

		function getBucketAsync(bucketId, cancellationToken) {
			return $http.get(uriUtility.fromPattern(assetCommonConfig.assetServiceBaseUri + 'buckets/{id}', { id: bucketId }), { token: cancellationToken })
				.then(function (response) {
					return mapBucket(response.data);
				});
		}

		return {
			getCurrentBucket: getCurrentBucket,
			setCurrentBucket: setCurrentBucket,
			getBucketsAsync: getBucketsAsync,
			getBucketAsync: getBucketAsync
		};
	}
	bucketService.$inject = ['$http', '$q', 'localSettingsService', '_', 'utility', 'uriUtility', 'assetCommonConfig'];
})();
